import { Switch } from '@/components/ui/switch';
import { formatCurrency, cn } from '@/lib/utils';

export interface PickerLine {
  id: string;
  category: string;
  description?: string | null;
  totalCost: number;
  itemized: boolean;
}

interface LineItemPickerGroupProps {
  lines: PickerLine[];
  selectedIds: string[];
  onToggleSelected: (id: string) => void;
  onToggleItemized: (id: string, current: boolean) => void;
  itemizedDisabled: boolean;
}

export function LineItemPickerGroup({
  lines,
  selectedIds,
  onToggleSelected,
  onToggleItemized,
  itemizedDisabled,
}: LineItemPickerGroupProps) {
  return (
    <div className="divide-y">
      {lines.map((li) => {
        const checked = selectedIds.includes(li.id);
        return (
          <div
            key={li.id}
            className={cn(
              'flex items-center gap-3 px-3 py-2.5 transition-colors',
              checked ? 'bg-blue-50/70' : 'hover:bg-gray-50',
            )}
          >
            <label className="flex min-w-0 flex-1 cursor-pointer items-center gap-3">
              <input
                type="checkbox"
                checked={checked}
                onChange={() => onToggleSelected(li.id)}
                aria-label={`Select ${li.description || li.category}`}
                className="h-4 w-4 shrink-0 rounded border-gray-300 text-blue-900 focus:ring-blue-900"
              />
              <div className="min-w-0">
                <p className="truncate text-sm font-medium text-gray-900">{li.category}</p>
                {li.description && (
                  <p className="truncate text-xs text-gray-500">{li.description}</p>
                )}
              </div>
            </label>
            <span className="w-24 shrink-0 text-right text-sm tabular-nums text-gray-700">
              {formatCurrency(li.totalCost)}
            </span>
            <div className="flex w-14 shrink-0 justify-center">
              <Switch
                checked={li.itemized}
                disabled={itemizedDisabled}
                onCheckedChange={() => onToggleItemized(li.id, li.itemized)}
                aria-label={`Itemize ${li.description || li.category}`}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
